import React from "react";
import {Routes, Route } from "react-router-dom";
import Home from "./components/Home"
import About from "./components/About"
import Header from "./components/Header";
import Footer from "./components/Footer";
import CareCircle from "./components/CareCircle";
import PlusFit from "./components/PulseFit"
 

function App() {
  return (
    <>
    <Header/>
      {/* <Home/> */}
      

      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="about" element={<About/>}/>
        <Route path="carecircle" element={<CareCircle/>}/>
        <Route path="pulsefit" element={<PlusFit/>}/>
      </Routes>
      <Footer/>
    </>
   
  );
}

export default App;
